// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBR_PoHWLYtHzcBWJjT_mGY71k_Onn0q3k",
  authDomain: "medcoopmsia-website.firebaseapp.com",
  projectId: "medcoopmsia-website",
  storageBucket: "medcoopmsia-website.firebasestorage.app",
  messagingSenderId: "340342826267",
  appId: "1:340342826267:web:fd3c7ecb716cf2dba79fbe",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
let analytics = null;
try {
  analytics = getAnalytics(app);
} catch (e) {
  console.warn('Analytics not available:', e.message);
}
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export { app, analytics, db, auth, storage };

